export default __webpack_public_path__ + "static/media/remove_button.c88272c3.svg";